import { TaskCustomComponent, TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'
import BasicTaskContent from 'modules/inbox_tasks/tasks/employeeLifecycleStepAction/BasicTask'
import { ManualTaskDefinition } from 'modules/inbox_tasks/tasks/manual'

const SmartFlowsActionExecutionTaskContent: TaskCustomComponent<'SmartFlowsActionExecution'> = ({
  taskId,
}) => <BasicTaskContent taskId={taskId} />

export const SmartFlowsActionExecutionTaskDefinition: TaskDefinition<'SmartFlowsActionExecution'> =
  {
    taskableTypename: 'SmartFlowsActionExecution',
    component: SmartFlowsActionExecutionTaskContent,
    useActions: ManualTaskDefinition.useActions,
  }
